import { mapMutations, mapActions, mapState } from 'vuex';

import internalUserSession from '@/js/services/api/internalUserSession';
import PersonalRecommendations from '@/js/store/modules/PersonalRecommendations';
import user from '@/js/store/modules/user';

export default {
  data: () => ({
    title: 'Рекомендуем вам',
    link: '/personal/recommendation/',
    interests: {
      quantity: 0,
      total: 20,
    },
    errorPage: false,
  }),
  created() {
    if (!this.$store.hasModule('PersonalRecommendations')) {
      this.$store.registerModule('PersonalRecommendations', PersonalRecommendations);
    }

    if (!this.$store.hasModule('user')) {
      this.$store.registerModule('user', user);
      const html = document.querySelector('html');
      this.setIsAuthorized(Boolean(html.dataset.authorized));
    }
  },
  computed: {
    ...mapState({
      isAuthorized: state => state.user.isAuthorized,
      hasRecommendations: state => state.PersonalRecommendations.hasRecommendations,
    }),
    enoughRatedBooks() {
      return this.interests.quantity >= this.interests.total;
    },
    restInterestsBooks() {
      return !this.enoughRatedBooks && this.interests.quantity > 0
        ? this.interests.total - this.interests.quantity
        : this.interests.total;
    },
  },
  destroyed() {
    this.$store.unregisterModule('user');
    this.$store.unregisterModule('PersonalRecommendations');
  },
  methods: {
    ...mapMutations('user', ['setIsAuthorized']),
    ...mapActions('PersonalRecommendations', ['getRecommendations']),
    getUserInterests() {
      return internalUserSession({
        isGetUserStats: true,
      })
        .then((data) => {
          this.interests.quantity = data.relationships?.userStats?.countRatings;
        });
    },
    async fetchUserInterestsAndRecommendations() {
      await Promise.all([
        this.getUserInterests(),
        this.getRecommendations(),
      ])
        .catch(() => { this.errorPage = true; });
    },
  },
};
